<template>
  <data-table
    v-model="selectedAllRows"
    :data="rows"
    :headers="headers"
    :loading="loading"
    :total-items="totalItens"
    :hide-edit="hideEdit"
    :hide-delete="hideDelete"
    :hide-data-table-bottom="hideDataTableBottom"
    :row-color-column="columnColor"
    :row-font-color-column="columnFontColor"
    :allow-select-all="allowSelectAll"
    :disable-set-query-string="disableSetQueryString"
    :table-name="tableName"
    :edit-icon="customEditIcon"
    @edit="editAction($event)"
    @delete="deleteAction($event)"
    @update-page="pageUpdated($event)"
    @update-rows-per-page="rowsPerPageUpdated($event)"
    @update-order="orderUpdated($event)"
    @update-row="rowUpdated($event)"
    @update-rows="updatedSelectedRows($event)"
    @updated-select-all-value="selectAllUpdated($event)"
    @update-selected-rows="updatedSelectedRows($event)"
    @select-all-status-change="selectAllStatusChange($event)"
  />
</template>

<script>
import DataTable from 'Support/components/data-table/DataTable.vue';
import RouterMixin from 'Support/mixins/router-mixin';
import PageableMixin from 'Support/mixins/pageable-mixin';
import NotificationMixin from 'Support/mixins/notification-mixin';
import DataTableService from 'Support/services/DatatableService';

export default {
  name: 'CrudList',
  components: {
    DataTable,
  },
  mixins: [RouterMixin, PageableMixin, NotificationMixin],
  data: vm => ({
    customEditIcon: 'edit',
    loading: false,
    hideEdit: false,
    hideDelete: false,
    hideDataTableBottom: true,
    allowSelectAll: false,
    columnColor: '',
    columnFontColor: '',
    tableName: vm.$options.name,
    deleteConfirmTitleMessage: vm.$t('support.components.crudList.deleteConfirmTitleMessage'),
    deleteConfirmTextMessage: vm.$t('support.components.crudList.deleteConfirmTextMessage'),
    selectedAllRows: [],
  }),
  watch: {
    totalItens: {
      handler(value) {
        this.$root.$emit(`total-itens-${this.tableName}`, value);
      },
    },
    loading: {
      handler(value) {
        this.$root.$emit(`loading-crud-${this.tableName}`, value);
      },
    },
    rows: {
      immediate: true,
      deep: true,
      handler(data) {
        if (Array.isArray(data)) {
          this.selectedAllRows = data.map(
            ({ id }) => ({
              id,
              value: false,
            }),
          );
        }
      },
    },
  },
  created() {
    this.$root.$on(`refresh-crud-${this.tableName}`, (value) => {
      if (value) this.getData();
    });
  },
  beforeCreate() {
    const filters = DataTableService.getFilters(this.$options.name);
    if (Object.keys(this.$route.query).length === 0 && filters !== null) {
      this.$router.push({ query: filters });
    }
  },
  methods: {
    rowUpdated(rows) {
      return rows;
    },
    getData() {
      this.loading = true;
      this.makeRequest();
    },
    makeRequest() {
      this.makeRestRequest();
    },
    makeRestRequest() {
      const params = this.transformSortQueryParams({
        ...this.getFaultFilterList(),
        ...this.getQueryParams(),
      });
      this.requestClass.list(params).then(({ data }) => {
        this.handleResponse(data.content, data.totalElements);
      }).catch(() => {
        this.loading = false;
      });
    },
    transformSortQueryParams(params) {
      const copy = { ...params };
      const retorno = {};

      copy.page -= 1;
      copy.size = copy.limit;
      delete copy.limit;

      if (copy.sortBy) {
        let orderBy = 'ASC';
        if (copy.orderBy === 'desc') {
          orderBy = 'DESC';
        }
        retorno.orderBy = copy.sortBy;
        retorno.order = orderBy;
        delete copy.sortBy;
        delete copy.orderBy;
      }
      Object.assign(retorno, copy);
      return retorno;
    },
    getFaultFilterList() {
      return {};
    },
    handleResponse(rows, total) {
      this.totalItens = total;
      this.rows.splice(0);
      this.rows.push(...rows.map(item => this.mapRequestItem(item)));
      this.loading = false;
    },
    editAction(item) {
      this.navigateTo(this.editRoute, { id: item.id });
    },
    deleteAction(row) {
      this.showConfirmDeleteDialog({
        title: this.deleteConfirmTitleMessage,
        text: this.deleteConfirmTextMessage,
      }).then((data) => {
        if (data.value) {
          this.makeDelete(row).then(() => {
            this.removeFromListAfterDelete(row);
            this.deleteSuccess(data);
          }).catch((error) => {
            this.deleteError(error);
          }).finally(() => {
            this.getData();
          });
        }
      });
    },
    removeFromListAfterDelete(row) {
      const indexDeleted = this.rows.indexOf(row);
      this.rows.splice(indexDeleted, 1);
    },
    makeDelete(row) {
      return this.makeRestDelete(row);
    },
    makeRestDelete(row) {
      return this.requestClass.remove(row.id);
    },
    deleteSuccess() {
      this.showSuccessToast({
        text: this.$t('support.components.crudList.deleteSuccess'),
      });
    },
    deleteError() {
      this.showOkDialog({
        title: this.$t('support.components.crudList.deleteErrorTitle'),
        text: this.$t('support.components.crudList.deleteErrorText'),
      });
    },
    mapRequestItem(item) {
      if (typeof this.mapItemMethod !== 'undefined') {
        return this.mapItemMethod(item);
      }

      return item;
    },
    updatedSelectedRows(rows) {
      this.$emit('update-selected-rows', rows);
    },
    selectAllUpdated(event) {
      this.$emit('updated-select-all-value', {
        selected: event,
        rows: this.rows,
      });
    },
    selectAllStatusChange(status) {
      this.$emit('select-all-status-change', status);
    },
  },
};
</script>
